import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions } from './base';
import { actions as userInfoActions } from '../../appstate/userInfo';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset(processingId) {
    return actions.reset(processingId);
}

function fetch(urlForPollingTicket, processingId, type) {
    return async (dispatch) => {
        dispatch(actions.startWork(processingId));

        let meta;
        let error;
        try {
            const downloadUrl = await AccountService.fetchTicketUrl(
                urlForPollingTicket,
                processingId,
                type,
            );

            return dispatch(userInfoActions.setTicketDownloadUrl({
                processingId,
                downloadUrl,
            }));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTicketUrl', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(processingId, meta, error));
        }
    };
}

export {
    fetch,
    reset,
};
